export default __webpack_public_path__ + "static/media/testimonials-3.bec51ce1.jpg";